import { Link } from 'react-router-dom';
import type { ConviteDivulgar } from '../types';
import { formatarDiaMes, formatarReais } from '../utils';

interface Props {
  convite: ConviteDivulgar;
}

export default function CartaoConvite({ convite }: Props) {
  const inicial = (convite.nome || '?').trim().charAt(0).toUpperCase();
  const cidade = [convite.cidade, convite.uf].filter(Boolean).join('/');
  const local = [convite.local_nome, cidade].filter(Boolean).join(' · ');
  const preco =
    convite.a_partir_de_reais != null && convite.a_partir_de_reais !== ''
      ? formatarReais(convite.a_partir_de_reais)
      : null;
  const vagas =
    typeof convite.vagas_restantes === 'number' &&
    convite.vagas_restantes > 0 &&
    convite.vagas_restantes <= 20
      ? convite.vagas_restantes
      : null;

  return (
    <div className="overflow-hidden rounded-xl border border-secondary-200 bg-white">
      {convite.imagem_url ? (
        <div className="relative aspect-[16/9] w-full overflow-hidden bg-secondary-100">
          <img
            src={convite.imagem_url}
            alt={convite.nome}
            title={`${convite.nome} — evento católico`}
            className="h-full w-full object-contain object-center"
          />
        </div>
      ) : (
        <div className="flex aspect-[16/9] w-full items-center justify-center bg-primary-500">
          <span className="text-5xl font-semibold text-white">{inicial}</span>
        </div>
      )}

      <div className="p-5">
        <h3 className="text-lg font-semibold text-foreground-950">{convite.nome}</h3>

        <div className="mt-3 space-y-1.5">
          {convite.inicio_em && (
            <p className="flex items-center gap-2 text-sm text-foreground-600">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-calendar-line" />
              </span>
              {formatarDiaMes(convite.inicio_em)}
            </p>
          )}
          {local && (
            <p className="flex items-center gap-2 text-sm text-foreground-600">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-map-pin-line" />
              </span>
              {local}
            </p>
          )}
        </div>

        {(preco || vagas) && (
          <div className="mt-4 space-y-1 border-t border-secondary-100 pt-4">
            {preco && (
              <p className="text-sm font-semibold text-foreground-900">A partir de {preco}</p>
            )}
            {vagas != null && (
              <p className="text-sm text-amber-700">
                {vagas === 1 ? '1 vaga restante' : `${vagas} vagas restantes`}
              </p>
            )}
          </div>
        )}

        <Link
          to={`/e/${convite.slug}`}
          className="mt-5 flex h-12 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
        >
          Quero saber mais
        </Link>
      </div>
    </div>
  );
}